(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.queue', {
            parent: 'public',
            url: '/queue/:eventId',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.queue': {
                    templateUrl: 'app/public/queue/queue.html',
                    controller: 'WaitListQueueController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.queue': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
